export default "__VITE_ASSET__jHH1q2FM__"